import styled from 'styled-components';
import { IconAlertAlt } from '@components/icons';
import { rgba } from 'polished';

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ theme }) => theme.zIndex.backdrop};
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${({ theme }) => `${rgba(theme.colors.functional.darkestGray, 0.1)}`};
  backdrop-filter: blur(8px);
  :focus {
    outline: none;
  }
`;

export const Container = styled.div`
  position: fixed;
  top: 4rem;
  left: 4rem;
  right: 4rem;
  z-index: ${({ theme }) => theme.zIndex.backdrop + 1};
  height: auto;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md}) {
    top: 1rem;
    left: 1rem;
    right: 1rem;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  padding: 5vh;
  max-height: 90vh;
  overflow: hidden;
  width: ${({ theme }) => theme.navBreakPoints.lg};
  max-width: 96%;
  background-color: ${({ theme }) => theme.colors.functional.white};
  border-right: 10px solid transparent;
  border-radius: ${({ theme }) => theme.borderRadius.main};
  box-shadow: ${({ theme }) => theme.boxShadow.black};
  :focus {
    outline: none;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.lg}) {
  }
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md}) {
    padding: 3vh;
  }
`;

export const Content = styled.div`
  width: 100%;
  margin: auto;

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md}) {
    width: 570px;
    max-width: 100%;
  } ;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 2rem;
`;

export const Title = styled.h2<{ withMarginBottom?: boolean }>`
  ${({ withMarginBottom }) => withMarginBottom && `margin-bottom: 8px;`}
`;

export const CloseButton = styled.button`
  height: 16px;
  width: 16px;
  fill: ${({ theme }) => theme.colors.primary.main}
  :hover {
    opacity: 0.7;
  }
`;

export const DescriptionText = styled.p`
  display: inline-block;
  margin-bottom: 64px;
`;

export const TitleAndIconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  margin-right: 8px;
`;

export const AlertIcon = styled(IconAlertAlt)`
  fill: ${({ theme }) => theme.colors.secondary.red}
  width: 20px;
`;
